import React, { useState, useEffect } from "react";
import { sampleState } from "../common/defaultState";
import * as EmailValidator from "email-validator";
import HomeForm from "./home-form";


function Home(props) {
    const [phoneRequired, setPhoneRequired] = useState(false);

  const firstNameRef = React.createRef();

   // const [clearFormCheck, setclearFormCheck] =  useState(false);
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false);
  const [fstate, setfState] = useState(sampleState);

  const [imageOption, setImageOption] = useState("Y");
  const [prevFile, setPrevFile] = useState(null);
  const [imageList, setImageList] = useState([]);

  const [curQ, setCurQ] = useState(null);
  const [curA, setCurA] = useState(null);
  const [curAall, setCurAall] = useState([]);

  const [allQ, setAllQ] = useState([]);
  const [allA, setAllA] = useState([]);

  const [selectedQA, setSelectedQA] = useState([]);
  const [isShow, setIsShow] = useState(false);

  const [gisAddreses,setGISAddreses]= useState([]);
 

    const getQA = (ProblemSid) => {
        props.loadDiv("show");
    let currentQ = {};
    let allQ = [];
    let allA = [];
    clearQuestionAnswer();

    window
        .fetch(`GetQA?ProblemSid=${ProblemSid}&token=${props.token}`)
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
          try {
              props.loadDiv("hide");
          if (data.status === 0) {
            if (data.value.Questions) {
              allQ = [...data.value.Questions];
              currentQ = allQ.find((e) => e.QuestionSequence === 1);
              setCurQ(currentQ);
              setAllQ(allQ);
            }
            if (data.value.Answers) {
              allA = [...data.value.Answers];
              let currentAall = [];
              allA.forEach((e) => {
                if (e.QuestionId === currentQ.QuestionId) currentAall.push(e);
              });

              setCurAall(currentAall);
              setCurA(currentAall[0]);
              setAllA(allA);
            }
          } else {
            props.setAlerts(data.message, "danger");
          }
        } catch {}
      });
  };

    useEffect(() => {
        setfState(props.state);  
        setPhoneRequired(props.state["phone"].required);
        if (props.state["phone"].disable) { props.state["isFollowUpCall"].disable = true; }
    setIsShow(true);
  }, []);

    const setAndValidate = (val, name) => {

        let status = -1;
        if (name === "isFollowUpCall" && !fstate["isFollowUpCall"].disable) {
    
            if (val && !phoneRequired) {
                fstate["phone"].required = true;
                if (!fstate["phone"].value || fstate["phone"].value === "") { fstate["phone"].status = 1; }
                
            }
            else {
                fstate["phone"].required = phoneRequired;
                if (!phoneRequired ) {
                   // status = 0;
                    fstate["phone"].status = -1;
                    var phoneno = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
                   
                    if (fstate["phone"].value && fstate["phone"].value != "" && !phoneno.test(fstate["phone"].value)) {
                        fstate["phone"].status  = 1;
                    } else {
                        if(!fstate["phone"].value || fstate["phone"].value == "") fstate["phone"].status  = -1;
                    }

                }
            }
            
    }
  if (
    name === "email" &&
    val 
    &&
    val.length > 0
  ) {

    if (!EmailValidator.validate(val)) {
      status = 1;
    } else {
      status = 0;
    }
  } else {
    if (name === "phone") {
     // let phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        var phoneno = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
     // if (!val.match(phoneno)) {
        if (val && val!="" && !phoneno.test(val)) {
        status = 1;
      } else {
        status = 0;
      }
    } else {
      if (val) {
        status = 0;
      } else {
        if(fstate[name].required)
        status = 1;
      }
    }
  }
  
  setfState({
    ...fstate,
    [name]: { ...fstate[name], value: val, status },
  });

    if (name === fstate.problemLocation.name) {
  //  getAddreses(fstate.problemLocation.value)
  }

}

    const getAddreses = (address) => {
        props.clearAlerts();
        if (address && address.target && address.target.value) {

            fstate.problemLocation.valueDesc = address.target.value;
            let _address = address.target.value;
            setGISAddreses([]);
            // debugger
            let addressRequest = {
                address: _address,
                geocoderUrl: props.gcoderUrl,
                addressField: props.addressField,
                geomUrl: props.geomUrl,
                outSR: props.sp
            };

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(addressRequest),
            };

            if (_address) {
                window
                    .fetch("GeocodeXY", requestOptions)
                    .then((resp) => {
                        return resp.json();
                    })
                    .then((data) => {
                        if (data.status !== 0) {
                            {
                                props.setAlerts(data.message, "danger");
                                setGISAddreses([]);
                                return;
                            }
                        }
                        //console.log(data);
                        if (data.value.candidates && data.value.candidates.length == 0) {
                            props.setAlerts(props.translate(props.lang, "NoDataFound"), "warning");
                            setGISAddreses([]);
                            return;
                        }
                        let ids = [];
                        data.value.candidates.map(a => {
                          //  console.log(a);
                            ids.push(a.address);
                        });
                        let candidates = [];
                        ids.map(b => {
                            data.value.candidates.map(a => {
                                //console.log(a);
                                if (b === a.address) {
                                    let o = candidates.find(c => c.address == b);
                                    if (!o) {
                                        candidates.push(a);
                                      
                                    }
                                }
                               // ids.push(a.address);
                            });
                        });
                       // console.log(all);

                       // setGISAddreses(data.value.candidates);
                        setGISAddreses(candidates);
                    });
            }
            else {
                setGISAddreses([]);
            }
        } else {
            fstate.problemLocation.valueDesc = "";
            fstate.problemLocation.value = "";

        }
};

  const validate = (e) => {

    const _value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    
      if (
        e &&
        e.target 
        //&&
       // e.target.name === "email" &&
        //e.target.value// &&
        //e.target.value.length > 0
      ) {
        setAndValidate(_value,e.target.name);
      }

    // console.log(fstate);
  };

  const onchange = (e) => {
    try {
      e.preventDefault();
      if (e && e.target && e.target.value) getQA(e.target.value);
    } catch {}
  };

  const nextQA = (e) => {
      if (!curA.Answer || curA.Answer ==='Free-form Response') {
      return;
    }
    setfState({
      ...fstate,
      problemtype: { ...fstate["problemtype"], problemtypeq: false },
    });

    const object3 = { ...curQ, ...curA };
    let SelectedQA = [...selectedQA];
    SelectedQA.push(object3);

    setSelectedQA(SelectedQA);

    let nextQ = allQ.find((a) => a.QuestionId === curA.NextQuestionId);
    if (nextQ) {
      setCurQ(nextQ);
      let nextAall = [];
      allA.forEach((a) => {
        if (a.QuestionId === nextQ.QuestionId) {
          nextAall.push(a);
        }
      });
      setCurAall(nextAall);
      setCurA(nextAall[0]);
    } else {
      setCurQ(null);
      setCurA(null);
    }
  };

  const onSelectAnswer = (e) => {
    if (e && e.target && e.target.value) {
      if (e.target.tagName === "INPUT") {
        let answer = curAall.find(
          (el) => el.AnswerId.toString() === e.target.id.toString()
        );
        answer.Answer = e.target.value;
        setCurA(answer);
      } else {
        if (e.target.tagName === "DATE") {
          debugger;
        } else {
          let answer = curAall.find(
            (el) => el.AnswerId.toString() === e.target.value.toString()
          );
          setCurA(answer);
        }
      }
    }
  };

  const submitForm = () => {
    try {
      let runCreate = true;
        let _state =fstate;

        Object.values(_state).forEach((a) => {
            if (a.valid) {
                let status = -1;


                switch (a.name) {
                    case "problemtype":

                        break;
                    case "email":
                    case "phone":
                        if ((a.required && !a.disable && !a.value) || (a.status === 1)) {
                            a.status = 1;
                            status = 1;            
                        }
                        break;;
                    default: //some fields into state should not validate. They have status equal -1.
                        if (a.required && !a.disable && !a.value) {
                            a.status = 1;
                            status = 1;
                        }
                        break;
                }


                //if (a.required && a.status !== 0 && (a.name !== "problemtype" || a.name !== "email" || a.name !== "phone")) {
                //    a.status = 1;
                //    status = 1;
                //}

                //if ((!a.value && a.status===1) ||( a.value==="" && a.status === -1)) {
                //    a.status = 1;
                //    status = 1;
                //}

                //if (
                //    (a.value && a.name !== "email" && a.name !== "phone" && a.value.toString().length > 0 && a.name !== "problemtype") ||
                //  (a.name === "problemtype" && a.value !== -1)
                //) {
                //  a.status = 0;
                //  status = 0;
                //  }

                //if (a.name === "problemtype") {
                //  a.problemtypeq = false;
                //  if (a.value === -1 && a.required) {
                //    a.status = 1;
                //    status = 1;
                //  }
                //  if (a.value !== -1 && curA && curQ) {
                //    // a.status = 1;
                //    status = 1;
                //    a.problemtypeq = true;
                //  }
                //}

                if (status === 1) {
                  //  debugger
                    runCreate = false;
                    setfState({
                        ...fstate,
                        [a.name]: { ...fstate[a.name], status: 1 },
                    });
                }
            }

      });
        //console.log("fstate=>", fstate);
        //console.log(runCreate);

     
      if (runCreate) {
        createSR();
      } else {
        props.loadDiv("hide");
        setBtnSubmitDisabled(false);
      }
    } catch (ex) {
      console.log(ex);
      props.loadDiv("hide");
      setBtnSubmitDisabled(false);
    }
  };

  const createSR = () => {
    try {
      props.loadDiv("show", "In process...");
      setBtnSubmitDisabled(false);
      let qa = [];
      selectedQA.forEach((e) => {
        qa.push({ AnswerId: e.AnswerId, AnswerValue: e.Answer });
      });

      let phone = fstate.phone.value;
      if (phone) {
        if (phone.indexOf("-") === -1 && phone.Length === 10) {
          phone =
            phone.substring(0, 3) +
            "-" +
            phone.substring(3, 3) +
            "-" +
            phone.substring(6, 4);
        }
      } else {
        phone = "";
      }
      //  let emailRequestVal = fstate.emailRequest.value ? "N" : "Y"; //if checked => no emailing
     

      let SRequest = {
        ProblemSid: fstate.problemtype.value ? fstate.problemtype.value : "",
        //Address: fstate.address.value ? fstate.address.value : "",
          Address: fstate.problemLocation.value
          ? fstate.problemLocation.value
          : "",
        AptNum: fstate.addressaptnum.value ? fstate.addressaptnum.value : "",
        City: fstate.addresscity.value ? fstate.addresscity.value : "",
        X: fstate.coordinatesx.value ? fstate.coordinatesx.value : "",
        Y: fstate.coordinatesy.value ? fstate.coordinatesy.value : "",
        Zip: fstate.addresszipcode.value ? fstate.addresszipcode.value : "",
        InitiatedByApp: props.initiatedByApp ? props.initiatedByApp : "",
        CallerFirstName: fstate.firstName.value ? fstate.firstName.value : "",
        CallerLastName: fstate.lastName.value ? fstate.lastName.value : "",
        CallerHomePhone: phone, // fstate.phone.value ? fstate.phone.value : "",
        CallerEmail: fstate.email.value ? fstate.email.value : "",
        //Location: fstate.problemLocation.value
        //  ? fstate.problemLocation.value
        //  : "",
          Location: fstate.locationDetails.value
          ? fstate.locationDetails.value
          : "",

        //Details: fstate.locationDetails.value
        //  ? fstate.locationDetails.value
        //  : "",
          Details: fstate.additionalDetail.value
              ? fstate.additionalDetail.value
              : "",

        //Comments: fstate.additionalDetail.value
        //  ? fstate.additionalDetail.value
        //  : "",
         // emailRequest: emailRequestVal, field name "emailRequest" is not exist. I populate Text1
         // Text1: emailRequestVal,
          emailRequest: fstate.emailRequest.value ? fstate.emailRequest.value: true,
          CallerIsFollowUpCall: fstate.isFollowUpCall.value
          ? fstate.isFollowUpCall.value
          : false,
          Answers: qa,
        token:props.token
      };

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(SRequest),
      };

      window
        .fetch("CreateSR", requestOptions)
        .then((resp) => {
          return resp.json();
        })
        .then((data) => {
            try {


            if (data.status === 0) {

                let message = `Service Request ${data.value} `;
                let messageType = "success";

                //-----validate preference status
                if (data.statusPreferences !== 0) {
                    message += `${data.messagePreferences}`;
                    messageType="warning";
                }
                //----validate emeil status
                if (data.statusEmail !== 0) {
                    message += `${data.messageEmail}`;
                    messageType = "warning";
                }

                if (fstate.imageList && fstate.imageList.length > 0) {
                    uploadAttachments(data.value, message, messageType);
                } else {
                    props.setAlerts(message, messageType);
                    clearForm();
                    props.loadDiv("hide");
                    try { window.scrollTo(0, 0); }catch{ }

                }

            } else {
                props.setAlerts(data.message, "danger");
                props.loadDiv("hide");
            }
          } catch {}
         // props.loadDiv("hide");
        });
    } catch (ex) {
      console.log(ex);
      props.loadDiv("hide");
    }
  };

    const uploadAttachments = (SRequestId, message, messageType ) => {

        let index = 0;
        fstate.imageList.forEach((a) => {
            try {
                let vFD = new FormData();
                let file= a.file;

                vFD.append('uploadFile', file);
                vFD.append('name', a.filename);
                vFD.append('requestId', SRequestId);
                vFD.append('token', props.token);
              //  vFD.append('token', this.model.token);

                const h = {}; //headers
                h.Accept = 'application/json';

                const requestOptions = {
                    method: "POST",
                    headers: h,//{ "Content-Type": "application/json" },
                    body: vFD,
                };

                window
                    .fetch("UploadFileApi", requestOptions)
                    .then((resp) => {
                        return resp.json();
                    })
                    .then((data) => {
                        try {
                            if (data.status === 0) {
                               // console.log(data.value);
                                ++index;
                                if (index === fstate.imageList.length) {
                                    //props.setAlerts(`Service Request ${SRequestId}`, "success");
                                    props.setAlerts(message, messageType);
                                    clearForm();
                                    props.loadDiv("hide");
                                }
                            } else {
                                message += `${data.message}`;
                                messageType = "warning";
                                props.setAlerts(message, messageType);
                               // props.setAlerts(`On attach ${a.filename} to Service Request ${SRequestId}.  ${data.message}`, "danger");
                                props.loadDiv("hide");
                            }
                        } catch (e) {
                            message += `${e}`;
                            messageType = "warning";
                            props.setAlerts(message, messageType);
                            //props.setAlerts(`On attach ${a.filename} to Service Request ${SRequestId}. ${e}`, "danger");
                            props.loadDiv("hide");
                        }
                      
                    });


            } catch (e) {
                props.setAlerts(`On attach ${a.filename} to Service Request ${SRequestId}.  ${e}`, "danger");
                props.loadDiv("hide");
            }
        });

       
    }

  const clearQuestionAnswer = () => {
    setCurQ(null);
    setCurA(null);
    setAllQ(null);
    setCurAall([]);
    setSelectedQA([]);
  };

  const clearImages = () => {
    setImageOption("N");
    setPrevFile(null);
    setTimeout(() => {
      let _imageList = [];
      setfState({
        ...fstate,
        imageList: _imageList,
      });
      setImageList([]);
    }, 500);
  };

  const clearValues = () => {
    let _state = fstate;
    Object.values(_state).forEach((a) => {
      a.value = "";
      a.status = -1;
      setfState({
        ...fstate,
        [a.name]: { ...fstate[a.name], status: a.status },
      });
    });
  };

  const clearForm = (e) => {
      props.loadDiv("show", "In process...");

    clearQuestionAnswer();
    clearImages();
      clearValues();
      fstate.problemtype.valueDesc = "";
      fstate.problemLocation.valueDesc = "";

      props.loadDiv("hide");
      props.showHome();
      //setclearFormCheck(true);
  };

  const attach = (e) => {
    let blob = URL.createObjectURL(e.target.files[0]);

    let img = {
      filename: e.target.files[0].name,
      type: e.target.files[0].type,
      data: blob,
      preview: true,
        guid: props.Guid(),
        file: e.target.files[0]
    };

    let _imageList = fstate.imageList ? [...fstate.imageList] : [];
    _imageList.push(img);

    setfState({
      ...fstate,
      imageList: _imageList,
    });
    setImageList(_imageList);
  };

  const deleteAttach = (e, guid) => {
    let _imageList = fstate.imageList ? [...fstate.imageList] : [];
    let img = [];
    _imageList.forEach((a) => {
      if (a.guid !== guid) img.push(a);
      else {
        if (a.preview === false) setPrevFile(null);
      }
    });
    setfState({
      ...fstate,
      imageList: img,
    });
    setImageList(img);
  };
  const previewAttach = (e, guid) => {
    let img = null;
    let _imageList = fstate.imageList ? [...fstate.imageList] : [];
    setPrevFile(null);
    _imageList.forEach((a) => {
      if (a.guid === guid) {
        img = a;
        a.preview = !a.preview;
      } else {
        a.preview = true;
      }
    });

    setImageList(_imageList);
    if (img.preview) setPrevFile(null);
    else setPrevFile(img.data);
  };

  const onChangeImageOption = (e) => {
    if (e && e.target && e.target.id) {
      let opt = e.target.id.replace("option", "");
      setImageOption(opt);
      if (opt === "N") {
        clearImages();
      }
    }
  };

  const onSearchChange = (selectedOption) => {
    if (selectedOption) {
      setfState({
        ...fstate,
        problemLocation: {
          ...fstate.problemLocation,
          value: selectedOption.label,
        },
        coordinatesx: { ...fstate.coordinatesx, value: selectedOption.x },
        coordinatesy: { ...fstate.coordinatesy, value: selectedOption.y },
      });
    } else {
      setfState({
        ...fstate,
        problemLocation: {
          ...fstate.problemLocation,
          value: "",
        },
        coordinatesx: { ...fstate.coordinatesx, value: 0.0 },
        coordinatesy: { ...fstate.coordinatesy, value: 0.0 },
      });
    }
  };

  const fetchData = (inputVal, callback) => {
    setfState({
      ...fstate,
      problemLocation: {
        ...fstate.problemLocation,
        value: "",
      },
      coordinatesx: { ...fstate.coordinatesx, value: 0.0 },
      coordinatesy: { ...fstate.coordinatesy, value: 0.0 },
    });

    if (!inputVal) {
      return callback([]);
    } else {
      setTimeout(() => {
        let address = inputVal;

        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ address }),
        };

        window
          .fetch("GeocodeXY", requestOptions)
          .then((resp) => {
            return resp.json();
          })
          .then((data) => {
            try {
              if (data.status === 0) {
                if (data && data.value) {
                  let js = JSON.parse(data.value);
                  let items = js.candidates;
                  if (items && items.length > 0) {
                    const optionsList = items.map((i) => ({
                      label: i.address,
                      x: i.location["x"],
                      y: i.location["y"],
                      score: i.score,
                    }));

                    setTimeout(() => {
                      return callback(optionsList);
                    }, 500);
                  } else {
                    props.setAlerts(data.message, "danger");
                  }
                }
              }
            } catch {}
          });
      });
    }
  };

    const updateLocationAddress = (address, x, y, maprefresh, extent) => {
 
    setGISAddreses([]);
    setfState({
      ...fstate,
      problemLocation: {
        ...fstate.problemLocation,
          value: address,
          valueDesc: address
      },
      coordinatesx: { ...fstate.coordinatesx, value: x },
        coordinatesy: { ...fstate.coordinatesy, value: y },
        //x: { ...fstate.x, value: longitude },//-112.82845,49.69737
        //y: { ...fstate.y, value: latitude },
       //maprefresh:{...fstate.maprefresh,
       // value:(maprefresh)?(props.Guid()):fstate.maprefresh.value,
       // extent:extent}
      //maprefresh:{...fstate.maprefresh,
      //  value:(maprefresh)?(props.Guid()):fstate.maprefresh.value,
      //  extent:extent}
    });
   // console.log(fstate);
   // setMapRefresh(props.Guid());
    //console.log(maprefresh);

    };



  return (
    <>
      {isShow ? (
        <HomeForm
                  fstate={fstate}
                  validate={validate}
                  onchange={onchange}
                  onSelectAnswer={onSelectAnswer}
                  nextQA={nextQA}
                  onChangeImageOption={onChangeImageOption}
                  attach={attach}
                  deleteAttach={deleteAttach}
                  previewAttach={previewAttach}
                  submitForm={submitForm}
                  clearForm={clearForm}
                  allQ={allQ}
                  curQ={curQ}
                  curA={curA}
                  curAall={curAall}
                  imageList={imageList}
                  prevFile={prevFile}
                  imageOption={imageOption}
                  selectedQA={selectedQA}
                  firstNameRef={firstNameRef}
                  onSearchChange={onSearchChange}
                  fetchData={fetchData}
                  changePage={props.changePage}
                  translate={props.translate}
                  lang={props.lang}
                  useTitle={props.useTitle}
                  usecaptcha={props.usecaptcha}
                  useTranslation={props.useTranslation}
                  useFontOptions={props.useFontOptions}
                  initiatedByApp={props.initiatedByApp}
                  isHome={props.isHome}
                  problemTypes={props.problemTypes}
                  changeLang={props.changeLang}
                  recaptchaSiteKey={props.recaptchaSiteKey}
                  loadDiv={props.loadDiv}
                  btnSubmitDisabled={btnSubmitDisabled}
                  setBtnSubmitDisabled={setBtnSubmitDisabled}
                  Guid={props.Guid}
                  getQA={getQA}
                  problemTypesCommon={props.problemTypesCommon}
                  updateLocationAddress={updateLocationAddress}
                  setAndValidate={setAndValidate}
                  gisAddreses={gisAddreses}
                  extent={props.extent}
                  sp={props.sp}
                  geomUrl={props.geomUrl}
                  geomToken={props.geomToken}
                  gcoderUrl={props.gcoderUrl}
                  gcoderToken={props.gcoderToken}
                  addressField={props.addressField}
                  geomTokenRequired={props.geomTokenRequired}
                  gcoderTokenRequired={props.gcoderTokenRequired}
                  fontSize={props.fontSize}
                  changeFont={props.changeFont}
                  getAddreses={getAddreses}
                  clearAlerts={props.clearAlerts}
                  mapZoom={props.mapZoom}

        />
      ) : (
        ""
      )}
    </>
  );
}

export default Home;
